import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';
import { persist } from 'zustand/middleware';

import { IClusterItem } from 'components/widgets/Gantt/components/ganttChart.types';

interface Props {
    cluster: IClusterItem | null;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}

const state: StateCreator<Props> = (set) => ({
    cluster: null,
    update: (value) => set({ ...value }),
});

export const useSharedResourcesStore = create(persist(state, { name: 'sharedResourcesAvailabilityCluster' }));
